import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const ExpectedBid = ({
  data,
}: {
  data?: IReportData['estimated_bid_analysis'];
}) => {
  const recommendText = (
    std: number,
    prc1: number,
    prc2: number,
    prc3: number,
  ) => {
    if (std === 1) {
      return `'감정가 대비 낙찰가율' 기반 입찰가 ${prc1 ? prc1.toLocaleString() : '-'}원을 추천함`;
    } else if (std === 2) {
      return `'최저입찰가 대비 낙찰가율' 기반 입찰가 ${prc2 ? prc2.toLocaleString() : '-'}원을 추천함`;
    } else {
      return `'시세 대비 낙찰가율' 기반 입찰가 ${prc3 ? prc3.toLocaleString() : '-'}원을 추천함`;
    }
  };

  return (
    <s.Div style={{ gap: '12px' }}>
      <s.Title>📈예상 입찰가 분석</s.Title>
      <s.TopDescription style={{ display: 'block' }}>
        과거 유사 물건 분석 결과,
        <br />
        {recommendText(
          data?.std || 0,
          data?.prc1 || 0,
          data?.prc2 || 0,
          data?.prc3 || 0,
        )}
        {/* <br />1 회차에는{' '}
        <span style={{ color: '#008AFF' }}>감정가 대비 낙찰가율</span>
        <br />2 회차 부터는
        <span style={{ color: '#F45551' }}>최저입찰가 대비 낙찰가율</span>을
        추천함. */}
      </s.TopDescription>
      <Table>
        <TableHeader>
          <Header>예상입찰가</Header>
          <Header style={{ width: 'calc(100% - 138px)' }}>수치</Header>
        </TableHeader>
        <Row>
          <RowLeft>
            <p style={{ color: '#008AFF' }}>
              {data?.prc1 ? data.prc1.toLocaleString() : '-'}원
            </p>
            <span>감정가 대비 낙찰가율</span>
          </RowLeft>
          <RowRight>
            <RowText color="#008AFF">{data?.rate1}%</RowText>
            <Pg_Bar percent={data?.rate1} color="#008AFF" />
          </RowRight>
        </Row>
        <Row>
          <RowLeft>
            <p style={{ color: '#F45551' }}>
              {data?.prc2 ? data.prc2.toLocaleString() : '-'}원
            </p>
            <span>최저입찰가 대비 낙찰가율</span>
          </RowLeft>
          <RowRight>
            <RowText color="#F45551">{data?.rate2}%</RowText>
            <Pg_Bar percent={data?.rate2} color="#F45551" />
          </RowRight>
        </Row>
        <Row>
          <RowLeft>
            <p style={{ color: '#37383C9C' }}>
              {data?.prc3 ? data.prc3.toLocaleString() : '-'}원
            </p>
            <span>시세 대비 낙찰가율</span>
          </RowLeft>
          <RowRight>
            <RowText color="#37383C9C">{data?.rate3}%</RowText>
            <Pg_Bar percent={data?.rate3} color="#37383C9C" />
          </RowRight>
        </Row>
      </Table>
    </s.Div>
  );
};

const Pg_Bar = ({ percent, color }: { percent: number; color: string }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '8px',
        borderRadius: '5px',
        background: '#70737C29',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: `${percent > 100 ? 100 : percent}%`,
          height: '100%',
          borderRadius: '5px',
          background: color,
          position: 'absolute',
        }}
      ></div>
    </div>
  );
};

export default ExpectedBid;

const Table = styled.table`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
`;

const TableHeader = styled.div`
  width: 100%;
  border-bottom: 1px solid #e5e8ea;
  display: flex;
  flex-direction: row;
`;

const Header = styled.div`
  width: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  padding-bottom: 10px;
`;

const Row = styled.div`
  width: 100%;
  height: 71px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
`;

const RowLeft = styled.div`
  width: 138px;
  height: 71px;
  display: flex;
  gap: 0px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-family: Spoqa Han Sans Neo;
  span {
    font-weight: 500;
    font-size: 11px;
    letter-spacing: ${11 * 0.02}px;
    line-height: 145%;
  }
  p {
    font-weight: 700;
    font-size: 16px;
    letter-spacing: ${16 * 0.02}px;
    line-height: 145%;
    margin: 0px;
  }

  color: #616161;
`;

const Price = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: rgba(55, 56, 60, 0.61);
`;

const Description = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #616161;
`;

const RowRight = styled.div`
  width: calc(100% - 138px);
  height: 71px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;

const RowText = styled.span<{ color: string }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${(props) => props.color};
`;
